import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/app/store';
import { IReportItem } from 'src/feature/Menu/menuModels';

interface IReportState {
  currentReport: IReportItem | null;
}

const initialState: IReportState = {
  currentReport: null,
};

export const slice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    updateCurrentReport: (state: IReportState, action: PayloadAction<IReportItem>) => {
      state.currentReport = action.payload;
    },
  },
});
export const { updateCurrentReport } = slice.actions;
export const getCurrentReport = (state: RootState) => state.report.currentReport;

export const ReportReducer = slice.reducer;
